import {HCL_HASH_STORE_KEY} from 'app/components/helpCenterListEs/constant';
import {ShouldSkipLazyLoadFn} from 'app/interface';
import {parseHashUrl} from 'app/utils/urlStateElements/parseHashUrl';

export const shouldSkipLazyLoad: ShouldSkipLazyLoadFn = () => {
    const urlState = parseHashUrl(window.location.hash.substring(1));
    return urlState[HCL_HASH_STORE_KEY] ? 'LOAD_EAGER' : 'LOAD_LAZY';
};
